import { ACCOUNT_PROVIDERS, MerkAssetBasic } from "@letsbit/malcolmlb";
import { useAuthSWR } from "hooks/utils/useAuthSWR";
import { ApiContext } from "providers/ApiProvider";
import { useContext } from "react";
import { SWRResponse } from "swr";

export const SWR_GET_ASSETS_BASIC = "get-assets-basic";

export const useGetMerkAssetsBasic = (params: {
  provider: ACCOUNT_PROVIDERS;
}): SWRResponse<MerkAssetBasic[]> => {
  const { memberInstance } = useContext(ApiContext);

  const swr = useAuthSWR([SWR_GET_ASSETS_BASIC], async () => {
    const { data } = await memberInstance.merk.getAssetsByProvider(params);
    return data;
  });
  return swr;
};
